/**
 * The one label a finding's telemetry-resolved page URL renders under, on every
 * surface (#6094): dashboard cards, GitHub / Linear / Jira issue bodies, and the
 * MCP job output. Kept in one place so the wording never drifts between them.
 */
export const SOURCE_URL_LABEL = 'Source URL';

/**
 * The Markdown line surfacing a finding's `sourceUrl`, or `''` when none was
 * resolved (legacy jobs / no navigation telemetry) so callers can drop it. Used
 * by the GitHub issue + feedback body renderers, and via the shared renderer by
 * Linear.
 */
export function sourceUrlMarkdown(sourceUrl: string | undefined): string {
  return sourceUrl ? `**${SOURCE_URL_LABEL}:** ${sourceUrl}` : '';
}
